export const linkApi = 'https://apiemc.easydata.pt'
// export const linkApi = "http://localhost:8090"
